<template>
    <div :class="{'popover-content popover-menu': !mobile}">
        <a @click="notifyLocal" :href="altAppURL" :class="style">
            <v-icon icon="website" class="inline-s"/>
            {{altAppLabel}}
        </a>
    </div>
</template>

<script>
    import {vIcon} from '@/components/form';
    import config from '@/common/config';

    const {
        VUE_APP_MODE,
        VUE_APP_RELEASE_VERSION,
        VUE_APP_SWITCH_MODE_URL,
    } = config;

    export default {
        name: 'sandbox-menu-item',
        components: {vIcon},
        props: {
            mobile: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            style() {
                return !this.mobile ? 'popover-menu-item' : 'btn has-icon-left stack-s';
            },
            isLive() {
                return `${VUE_APP_MODE}` === 'live';
            },
            isLocal() {
                return VUE_APP_RELEASE_VERSION.startsWith('local');
            },
            altAppLabel() {
                return `Switch to ${this.isLive ? 'Sandbox' : 'Live'} Environment`;
            },
            altAppURL() {
                if (this.isLocal) {
                    return '#';
                }
                return VUE_APP_SWITCH_MODE_URL;
            },
        },
        methods: {
            notifyLocal(event) {
                if (this.isLocal) {
                    this.$toast.warning('Unable to switch modes locally.');
                    event.preventDefault();
                }
            },
        },
    };
</script>
